import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { t } from 'i18next';
import { Box, styled } from '@mui/material';

import {
  Button,
  Divider,
  InputAdornment,
  ListItemIcon,
  Menu,
  MenuItem,
  TextField,
  Typography,
} from '@datanomik/commons-ui';

import {
  ArrowRightSLine, GlobalLine, LogoutBoxRLine, Search2Line,
} from '@datanomik/commons-ui/icons';

import { useUserContext } from '@/contexts/user';
import { useWorkspaceContext } from '@/contexts/workspace';

import styles from './styles';
import { useClientButton } from './hooks';

const ClientButtonRaw = ({
  className,
  handleLoogut,
  anchorEl,
  handleClose,
  isMobile,
  open,
}) => {
  const textFieldRef = useRef();

  const {
    clients,
    searchText,
    handleChange,
  } = useClientButton();

  const {
    userSession: {
      multiClient,
      clientId,
    },
  } = useUserContext();

  const {
    workspace: { handleChangeWsAndClient },
  } = useWorkspaceContext();

  if (!multiClient) {
    return (
      <Button
        className={className}
        variant="outlined"
        color="black"
        startIcon={<LogoutBoxRLine />}
        size="xxsmall"
        onClick={handleLoogut}
      />
    );
  }

  const clientsList = clients.filter((el) => el.id !== clientId && (
    searchText === '' || el.company.toLowerCase().includes(searchText.toLowerCase())
  )).sort((a, b) => -b.company.localeCompare(a.company));

  return (
    <>
      <Button
        className={className}
        variant="outlined"
        color="black"
        startIcon={<ArrowRightSLine />}
        size="xxsmall"
        key="clients-button"
      />
      {open && (
        <Menu
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: isMobile ? 'top' : 'bottom',
            horizontal: isMobile ? 'right' : 'right',
          }}
          transformOrigin={{
            vertical: isMobile ? 'bottom' : 110,
            horizontal: isMobile ? 'right' : -24,
          }}
          sx={{
            zIndex: 3000,
            '.DnkPaper-root': {
              marginTop: '0 !important',
            },
          }}
        >
          <TextField
            inputRef={textFieldRef}
            className="dn-field-search"
            onChange={handleChange}
            value={searchText}
            name="searchText"
            type="search"
            placeholder={t('Search client')}
            size="small"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <Search2Line />
                  </InputAdornment>
                ),
              },
            }}
          />
          <Box
            className="dn-content"
            sx={{
              maxHeight: '220px',
              overflow: 'auto',
            }}
          >
            {
              clientsList.map(({
                id,
                company,
              }) => (
                <MenuItem
                  key={id}
                  onClick={() => handleChangeWsAndClient({ clientId: id, clientName: company })}
                >
                  <ListItemIcon color="neutral.500">
                    <GlobalLine />
                  </ListItemIcon>
                  <Typography sx={{ fontSize: '14px', color: 'neutral.900' }}>{company}</Typography>
                </MenuItem>
              ))
            }
          </Box>

          <Divider />

          <Box>
            <Button
              className={className}
              variant="text"
              startIcon={<LogoutBoxRLine />}
              size="xsmall"
              onClick={handleLoogut}
              color="neutral.900"
              sx={{ width: '100%' }}
            >
              {t('Logout')}
            </Button>
          </Box>
        </Menu>
      )}
    </>
  );
};

ClientButtonRaw.propTypes = {
  className: PropTypes.string,
  handleLoogut: PropTypes.func,
  anchorEl: PropTypes.object,
  handleClose: PropTypes.func,
  isMobile: PropTypes.bool,
  open: PropTypes.bool,
};

const ClientButton = styled(ClientButtonRaw)`${styles}`;

ClientButton.propTypes = ClientButtonRaw.propTypes;

export default ClientButton;
